import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { apiFetch } from '../../helpers/api';
import Loader from '../common/Loader';
import './News.css';

const News = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const scrollRef = useRef(null);
  const fetchNews = async () => {
    try {
      const data = await apiFetch("/api/news");
      const sorted = data.sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0)); // Sort by createdAt descending (latest first)
      setNews(sorted);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNews();
  }, []);

  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -300, behavior: 'smooth' });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 300, behavior: 'smooth' });
  };

  if (loading) return <Loader />;
  if (error) return <div>{t("error")}: {error}</div>;

  if (news.length === 0) {
    return (
      <div className="news-container empty-state">
        <h2>{t("aboutUs.news.title")}</h2>
        <div className="empty-news">
          <span role="img" aria-label="no-news" className="empty-icon">📰</span>
          <p className="empty-text">{t("aboutUs.news.noNews")}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="news-container">
      <h2>{t("aboutUs.news.title")}</h2>
      <div className="news-carousel-wrapper">
        {news.length > 1 && (
          <button className="news-scroll-button left" onClick={scrollLeft}>‹</button>
        )}

        <div
          className={`news-carousel${news.length === 1 ? " single-news" : ""}`}
          ref={scrollRef}
        >
          {news.map((item, index) => {
            const description = item.description || '';
            const shortDesc = description.length > 150 ? description.slice(0, 150) + "..." : description;

            return (
              <article
                key={item.id || index}
                className={`news-card${news.length === 1 ? " single-card" : ""}`}
              >
                <div className="news-image-wrap">
                  <img
                    src={item.imageUrl || item.image || 'https://picsum.photos/600/300?random=3'}
                    alt={item.title}
                    onError={e => e.target.src = 'https://picsum.photos/600/300?random=3'}
                    className="news-image"
                  />
                </div>
                <div className="news-content">
                  <h3 className="news-title">{item.title}</h3>
                  <p className="news-excerpt">{shortDesc}</p>
                  <div className="news-card-footer">
                    <button
                      className="read-more-btn"
                      onClick={() => navigate(`/news/${item.id}`)}
                    >
                      {t("aboutUs.news.readMore")}
                    </button>
                  </div>
                </div>
              </article>
            );
          })}
        </div>

        {news.length > 1 && (
          <button className="news-scroll-button right" onClick={scrollRight}>›</button>
        )}
      </div>
    </div>
  );
};

export default News;
